module.exports = __webpack_public_path__ + "static/sheep6-f2fe49bd4be3f4b1ce30232354d7d270.jpeg";